import { render, staticRenderFns } from "./HCS.vue?vue&type=template&id=3be0b3ba&"
import script from "./HCS.vue?vue&type=script&lang=js&"
export * from "./HCS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports